import { debounce } from '@quromedical/utils';
import React from 'react';

import { getTextColor } from './BaseButton';
import { Button, ButtonProps } from './Button';

export const DebounceButton: React.FC<ButtonProps> = ({
  variant = 'contained',
  shape = 'default',
  size = 'default',
  disabled = false,
  text = '',
  iconPosition = 'left',
  icon,
  unsetBottomLeftRadius,
  unsetBottomRightRadius,
  unsetTopLeftRadius,
  unsetTopRightRadius,
  iconSize = 'default',
  textColor = getTextColor(variant, disabled),
  onPress,
  textPosition = 'space-around',
}) => {
  const onPressDebounced = debounce(onPress, 1000, { leading: true, trailing: false });

  return (
    <Button
      onPress={onPressDebounced}
      disabled={disabled}
      variant={variant}
      shape={shape}
      size={size}
      unsetBottomLeftRadius={unsetBottomLeftRadius}
      unsetBottomRightRadius={unsetBottomRightRadius}
      unsetTopLeftRadius={unsetTopLeftRadius}
      unsetTopRightRadius={unsetTopRightRadius}
      text={text}
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      textColor={textColor}
      textPosition={textPosition}
    />
  );
};
